import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React, { Component } from "react";
import { css } from "styled-components/macro"; //eslint-disable-line
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Price from "components/pricing/ThreePlans.js";
import AgencyLandingPage from "demos/AgencyLandingPage.js";
import LoginPage from "pages/Login.js";
import SignupPage from "pages/Signup.js";
import CompleteProfilePage from "pages/CompleteProfile.js";
import AboutUs from "pages/AboutUs.js";
import SellerForm from "./components/SellerForm";
import BlogIndexPage from "pages/BlogIndex.js";
import TermsOfServicePage from "pages/TermsOfService.js";
import PrivacyPolicyPage from "pages/PrivacyPolicy.js";
import Client from 'components/CustomerSupport/Client';
import Agent from 'components/CustomerSupport/Agent';
import ComponentRenderer from "./ComponentRenderer";
import ShoppingCart from "components/pricing/ShoppingCart";
import TransactionHistory from "pages/TransactionHistory";
import AdminDashboard from "pages/AdminDashboard";
import PartnerDashboard from "pages/PartnerDashboard";
import CoBuyHub from "pages/CoBuyHub";
import CookieConsent from "components/CookieConsent";

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("Page crashed:", error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding:"2rem",textAlign:"center"}}>
          <h2>Something went wrong on this page.</h2>
          <p style={{color:"#888"}}>{this.state.error?.message}</p>
          <button onClick={() => window.location.href = "/"}>Go Home</button>
        </div>
      );
    }
    return this.props.children;
  }
}

/*
 * This is the entry point component of this project. You can change the below exported default App component to any of
 * the prebuilt landing page components by uncommenting their import and export lines respectively.
 * See one of the landing page components to better understand how to import and render different components (Always
 * make sure if you are building your own page, the root component should be the AnimationRevealPage component. You can
 * disable the animation by using the disabled prop.
 *
 * The App component below is using React router to render the landing page that you see on the live demo website
 * and the component previews.
 *
 */

/* Use AnimationRevealPage as a wrapper component for your pages if you are custom building it */
// import AnimationRevealPage from "helpers/AnimationRevealPage.js";

/*
 * Hero section is the top most section on the page. It contains the header as well.
 * So you dont need to import headers
 * separately
 */

// import Hero from "components/hero/TwoColumnWithVideo.js";
// import Hero from "components/hero/TwoColumnWithInput.js";
// import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
// import Hero from "components/hero/TwoColumnWithPrimaryBackground.js";
// import Hero from "components/hero/FullWidthWithImage.js";
// import Hero from "components/hero/BackgroundAsImage.js";
// import Hero from "components/hero/BackgroundAsImageWithCenteredContent.js";

// import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
// import Features from "components/features/ThreeColWithSideImageWithPrimaryBackground.js";
// import Features from "components/features/VerticalWithAlternateImageAndText.js";
// import Features from "components/features/DashedBorderSixFeatures";
// import MainFeature from "components/features/TwoColWithButton.js";
// import MainFeature from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
// import MainFeature from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
// import FeatureWithSteps from "components/features/TwoColWithSteps.js";
// import FeatureStats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";

// import Pricing from "components/pricing/ThreePlansWithHalfPrimaryBackground.js";
// import Pricing from "components/pricing/TwoPlansWithDurationSwitcher.js";

// import SliderCard from "components/cards/ThreeColSlider.js";
// import TrendingCard from "components/cards/TwoTrendingPreviewCardsWithImage.js";
// import Portfolio from "components/cards/PortfolioTwoCardsWithImage.js";
// import TabGrid from "components/cards/TabCardGrid.js";

// import Blog from "components/blogs/ThreeColSimpleWithImage.js";
// import Blog from "components/blogs/ThreeColSimpleWithImageAndDashedBorder.js";
// import Blog from "components/blogs/PopularAndRecentBlogPosts.js";
// import Blog from "components/blogs/GridWithFeaturedPost.js";

// import Testimonial from "components/testimonials/TwoColumnWithImage.js";
// import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
// import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
// import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
// import Testimonial from "components/testimonials/SimplePrimaryBackground.js";

// import FAQ from "components/faqs/SimpleWithSideImage.js";
// import FAQ from "components/faqs/SingleCol.js";
// import FAQ from "components/faqs/TwoColumnPrimaryBackground.js";

// import ContactUsForm from "components/forms/SimpleContactUs.js";
// import ContactUsForm from "components/forms/TwoColContactUsWithIllustration.js";
// import SubscribeNewsLetterForm from "components/forms/SimpleSubscribeNewsletter.js";
//
// import GetStarted from "components/cta/GetStarted.js";
// import GetStarted from "components/cta/GetStartedLight.js";
// import DownloadApp from "components/cta/DownloadApp.js";

// import Footer from "components/footers/SimpleFiveColumn.js";
// import Footer from "components/footers/FiveColumnWithInputForm.js";
// import Footer from "components/footers/FiveColumnWithBackground.js";
// import Footer from "components/footers/FiveColumnDark.js";
// import Footer from "components/footers/MiniCenteredFooter.js";

/* Ready Made Pages (from demos folder) */
// import EventLandingPage from "demos/EventLandingPage.js";
// import HotelTravelLandingPage from "demos/HotelTravelLandingPage.js";

// import SaaSProductLandingPage from "demos/SaaSProductLandingPage.js";
// import RestaurantLandingPage from "demos/RestaurantLandingPage.js";
// import ServiceLandingPage from "demos/ServiceLandingPage.js";
// import HostingCloudLandingPage from "demos/HostingCloudLandingPage.js";

/* Inner Pages */
// import PricingPage from "pages/Pricing.js";
//import MainLandingPage from "MainLandingPage.js";
// const SignIn = lazy(() => import("Authentication/SignIn"));
// const SignUp = lazy(() => import("Authentication/SignUp"));
//import SignIn from 'Authentication/SignIn'
//import SignUp from 'Authentication/SignUp'



{/* SignIn */}
/* const SignInComponent = (
  <Suspense
  fallback={
    <div className="loader-container">
      <div className="loader-container-inner">
        <div className="col-xl-12 my-auto text-center">
          <span className="spinner-border spinner-border-sm"></span>
        </div>            </div>
    </div>
  }
  >
    <Route path="/auth/sign-in" component={SignIn} />
  </Suspense>
)
 */
{/* SignUp */}
/* const SignUpComponent = (
  <Suspense
  fallback={
    <div className="loader-container">
      <div className="loader-container-inner">
        <div className="col-xl-12 my-auto text-center">
          <span className="spinner-border spinner-border-sm"></span>
        </div>            </div>
    </div>
  }
  >
    <Route path="/auth/sign-up" component={SignUp} />
  </Suspense>
)
 */ 


export default function App() {
  // return <AnimationRevealPage disabled></AnimationRevealPage>;
  return (
    <>
    <Router>
      <ErrorBoundary>
        <Switch>
          <Route path="/components/:type/:subtype/:name">
            <ComponentRenderer />
          </Route>
          <Route path="/components/:type/:name">
            <ComponentRenderer />
          </Route>
          <Route path='/agent'>
            <Agent />
          </Route>
          <Route path="/tos">
            <TermsOfServicePage />
          </Route>
          <Route path="/privacy">
            <PrivacyPolicyPage />
          </Route>
          <Route path="/login">
            <LoginPage />
          </Route>
          <Route path="/signup">
            <SignupPage />
          </Route>
          <Route path="/complete-profile">
            <CompleteProfilePage />
          </Route>
          <Route path="/checkout">
            <ShoppingCart />
          </Route>
          <Route path="/history">
            <TransactionHistory />
          </Route>
          <Route path="/co-buy">
            <CoBuyHub />
          </Route>
          <Route path="/marketplace">
            <BlogIndexPage />
          </Route>
          <Route path="/aboutus">
            <AboutUs />
          </Route>
          <Route path="/seller">
            <SellerForm />
          </Route>
          <Route path="/admin">
            <AdminDashboard />
          </Route>
          <Route path="/partner">
            <PartnerDashboard />
          </Route>
          <Route path="/teststore">
            <Price />
          </Route>
          <Route path="/shop">
            <ShoppingCart />
          </Route>
          <Route exact path="/">
            <AgencyLandingPage />
          </Route>
        </Switch>
      </ErrorBoundary>
      <CookieConsent />
    </Router>

    <Client />
    </>
  );
}



// export default EventLandingPage;
// export default HotelTravelLandingPage;
// export default AgencyLandingPage;
// export default SaaSProductLandingPage;
// export default RestaurantLandingPage;
// export default ServiceLandingPage;
// export default HostingCloudLandingPage;

// export default LoginPage;
// export default SignupPage;
// export default PricingPage;
// export default AboutUsPage;
// export default ContactUsPage;
// export default BlogIndexPage;
// export default TermsOfServicePage;
// export default PrivacyPolicyPage;

// export default MainLandingPage;



/*addUser = e => {
  e.preventDefault();
  const db = firebase.firestore();
  db.settings({
    timestampsInSnapshots: true
  });
  const userRef = db.collection(“users”).add({
    fullname: this.state.fullname,
    email: this.state.email
  });  
  this.setState({
    fullname: “”,
    email: “”
  });
};
*/



/*

//	myInfo.once('value', function(snap) {
	//			if (snap.val() !== null) {

//					if (snap.val().age == null && snap.val().country == null && snap.val().gender == null) {



 performLogin = () => {
    this.setState({ loginInProgress: true });
    client.login().then(() => (
      this.setState({ shouldRedirect: true })
    ));
  };  



class App extends Component {
  constructor() {
    super();
    this.state = {
      authenticated: false,
      loading: true,
    };
  }

  componentDidMount() {
  auth().onAuthStateChanged((user) => {
    if (user) {
      this.setState({
        authenticated: true,
        loading: false,
      });
    } else {
      this.setState({
        authenticated: false,
        loading: false,
      });
    }
  })
}

}

render() {
  return this.state.loading === true ? <h2>Loading...</h2> : (
    <Router>
      <Switch>
        <Route exact path="/" component={Home}></Route>
        <PrivateRoute path="/chat" authenticated={this.state.authenticated} component={Chat}></PrivateRoute>
        <PublicRoute path="/signup" authenticated={this.state.authenticated} component={Signup}></PublicRoute>
        <PublicRoute path="/login" authenticated={this.state.authenticated} component={Login}></PublicRoute>
      </Switch>
    </Router>
  );

  export default App;
}


// Add a second document with a generated ID.
db.collection("users").add({
    first: "Alan",
    middle: "Mathison",
    last: "Turing",
    born: 1912
})
.then((docRef) => {
    console.log("Document written with ID: ", docRef.id);
})
.catch((error) => {
    console.error("Error adding document: ", error);
});


OR

//if you're not sure doc exist, merges both, avoid overwriting
var cityRef = db.collection('cities').doc('BJ');

var setWithMerge = cityRef.set({
    capital: true
}, { merge: true });



OR

//allows different types of data
var docData = {
    stringExample: "Hello world!",
    booleanExample: true,
    numberExample: 3.14159265,
    dateExample: firebase.firestore.Timestamp.fromDate(new Date("December 10, 1815")),
    arrayExample: [5, true, "hello"],
    nullExample: null,
    objectExample: {
        a: 5,
        b: {
            nested: "foo"
        }
    }
};
db.collection("data").doc("one").set(docData).then(() => {
    console.log("Document successfully written!");
});


// Add a new document with a generated id.
db.collection("cities").add({
    name: "Tokyo",
    country: "Japan"
})
.then((docRef) => {
    console.log("Document written with ID: ", docRef.id);
})
.catch((error) => {
    console.error("Error adding document: ", error);
});



// Add a new document with a generated id.
var newCityRef = db.collection("cities").doc();

// later...
newCityRef.set(data);

Important: Unlike "push IDs" in the Firebase Realtime Database, Cloud Firestore auto-generated IDs do not provide any automatic ordering. If you want to be able to order your documents by creation date, you should store a timestamp as a field in the documents.
Behind the scenes, .add(...) and .doc().set(...) are completely equivalent, so you can use whichever is more convenient.


db.collection("users").get().then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
        console.log(`${doc.id} => ${doc.data()}`);
    });
});


//update
var washingtonRef = db.collection("cities").doc("DC");

// Set the "capital" field of the city 'DC'
return washingtonRef.update({
    capital: true
})
.then(() => {
    console.log("Document successfully updated!");
})
.catch((error) => {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
});






// Allow read/write access on all documents to any user signed in to the application
service cloud.firestore {
  match /databases/{database}/documents {
    match /{document=**} {
      allow read, write: if request.auth != null;
    }
  }
}

*/

